import { GraphQLError } from 'common/gql/GraphQLError';

export enum RECLAMATION_REQUEST_ERROR_CODE {
  VALIDATION_ERROR = 1,
  SERIALIZATION_ERROR = 2,
  AUTHORIZATION_FAILED = 3,
  RECLAMATION_ALREADY_SUBMITTED = 4,
  FAILED_PROCESS_ATTACHMENT = 5,
  CONCURRENT_WRITE = 6,
  STATE_CHANGE_NOT_ALLOWED = 7,
}

const RECLAMATION_REQUEST_ERROR_CODES = Object.values(RECLAMATION_REQUEST_ERROR_CODE);

interface ReclamationRequestGraphQLError extends GraphQLError {
  extensions: {
    code: RECLAMATION_REQUEST_ERROR_CODE;
  };
}

export const isReclamationRequestGraphQLError = (
  error: unknown
): error is ReclamationRequestGraphQLError =>
  error instanceof GraphQLError &&
  RECLAMATION_REQUEST_ERROR_CODES.includes(error.extensions.code as RECLAMATION_REQUEST_ERROR_CODE);
